var _g, _rect, _path, _g2, _rect2, _g3, _rect3, _path2, _g4, _rect4, _path3, _g5, _rect5, _g6, _rect6, _path4, _g7, _rect7, _path5, _g8, _rect8, _path6, _g9, _rect9, _path7, _g10, _rect10, _path8, _g11, _rect11, _g12, _rect12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGame1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 276,
    height: 223,
    viewBox: "0 0 276 223",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_77_341)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.2531,
    y: 6,
    width: 46.9879,
    height: 46.9879,
    rx: 12.5301,
    fill: "#474785"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 65.9519,
    y: 10.6989,
    width: 37.6024,
    height: 37.6024,
    rx: 7.83133,
    fill: "url(#paint0_linear_77_341)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.1015 33.6279C82.8572 34.9812 81.5227 35.6578 79.117 35.6578C76.6548 35.6578 75.3391 34.9812 75.1512 33.6279L73.3281 20.7344H77.7449L78.8914 30.5455C78.9478 30.9778 79.2861 31.1845 79.9252 31.1845C80.5454 31.1845 80.9025 30.9778 80.9589 30.5455L81.8987 24.0612C82.0302 23.2154 82.7068 22.7831 83.9285 22.7831C85.1502 22.7831 85.8456 23.2342 85.9772 24.1364L86.9734 30.5455C87.0297 30.9778 87.3868 31.1845 88.0071 31.1845C88.6461 31.1845 88.9844 30.9778 89.0408 30.5455L90.0746 20.7344H94.5854L92.6871 33.6279C92.4803 34.9812 91.1647 35.6578 88.7213 35.6578C86.3155 35.6578 84.9811 34.9812 84.7367 33.6279L83.9285 29.1171L83.1015 33.6279Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_77_341)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 167.759,
    y: 6,
    width: 46.9879,
    height: 46.9879,
    rx: 12.5301,
    fill: "#666672"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 172.458,
    y: 10.6989,
    width: 37.5904,
    height: 37.5904,
    rx: 7.83133,
    fill: "url(#paint1_linear_77_341)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_77_341)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 59.2531,
    width: 46.9879,
    height: 46.9879,
    rx: 12.5301,
    fill: "#E87785"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.6989,
    y: 63.9519,
    width: 37.5904,
    height: 37.5904,
    rx: 7.83133,
    fill: "url(#paint2_linear_77_341)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8683 78.893L28.6428 80.1899C28.5864 80.5094 28.6616 80.7537 28.8307 80.9229C28.9999 81.0921 29.3946 81.186 30.0336 81.186C30.6351 81.186 31.0486 81.1109 31.2553 80.9417C31.4621 80.7725 31.5373 80.5282 31.4809 80.1899L31.2929 78.893C31.2365 78.4795 30.823 78.2728 30.09 78.2728C29.357 78.2728 28.9435 78.4795 28.8683 78.893ZM26.331 75.8294C26.6881 74.4762 27.9474 73.7995 30.1088 73.7995C32.2891 73.7995 33.5483 74.4762 33.9054 75.8294L37.251 88.7229H32.8341L32.383 85.9224C32.2515 85.0766 31.5185 84.6631 30.2028 84.6631C28.8871 84.6631 28.1541 85.0766 27.985 85.9224L27.4399 88.7229H22.9479L26.331 75.8294Z",
    fill: "white"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_77_341)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.2531,
    y: 59.2531,
    width: 46.9879,
    height: 46.9879,
    rx: 12.5301,
    fill: "#474785"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 65.9519,
    y: 63.9519,
    width: 37.6024,
    height: 37.6024,
    rx: 7.83133,
    fill: "url(#paint3_linear_77_341)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1214 78.893L81.8958 80.1899C81.8395 80.5094 81.9146 80.7537 82.0838 80.9229C82.253 81.0921 82.6477 81.186 83.2867 81.186C83.8881 81.186 84.3016 81.1109 84.5084 80.9417C84.7151 80.7725 84.7903 80.5282 84.7339 80.1899L84.546 78.893C84.4896 78.4795 84.0761 78.2728 83.3431 78.2728C82.6101 78.2728 82.1966 78.4795 82.1214 78.893ZM79.584 75.8294C79.9411 74.4762 81.2004 73.7995 83.3619 73.7995C85.5421 73.7995 86.8014 74.4762 87.1585 75.8294L90.504 88.7229H86.0872L85.6361 85.9224C85.5045 85.0766 84.7715 84.6631 83.4558 84.6631C82.1402 84.6631 81.4072 85.0766 81.238 85.9224L80.693 88.7229H76.2009L79.584 75.8294Z",
    fill: "white"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_77_341)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 167.759,
    y: 59.2531,
    width: 46.9879,
    height: 46.9879,
    rx: 12.5301,
    fill: "#666672"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 172.458,
    y: 63.9519,
    width: 37.5904,
    height: 37.5904,
    rx: 7.83133,
    fill: "url(#paint4_linear_77_341)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_77_341)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 112.506,
    width: 46.9879,
    height: 46.9879,
    rx: 12.5301,
    fill: "#474785"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 12.6989,
    y: 117.205,
    width: 37.6024,
    height: 37.6024,
    rx: 7.83133,
    fill: "url(#paint5_linear_77_341)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9816 131.545L30.2491 131.526C28.8959 131.507 28.2004 131.939 28.1441 132.785L27.9373 135.773C27.8809 136.619 28.0125 137.145 28.2944 137.352C28.5763 137.54 29.0462 137.653 29.7041 137.672L32.1662 137.785V136.638C32.1662 135.943 32.373 135.416 32.8053 135.097C33.2188 134.777 33.6886 134.608 34.2337 134.608C34.76 134.608 35.2298 134.796 35.6621 135.191C36.0756 135.585 36.3012 136.055 36.3388 136.638L36.7335 142.277L30.1739 142.314C27.599 142.333 25.7759 141.769 24.6857 140.623C23.5956 139.476 23.1633 138.01 23.3889 136.187L23.8024 132.841C24.2723 128.988 26.4713 127.052 30.3807 127.052L35.9629 127.071L35.9816 131.545Z",
    fill: "white"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_77_341)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.2531,
    y: 112.506,
    width: 46.9879,
    height: 46.9879,
    rx: 12.5301,
    fill: "#474785"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 65.9519,
    y: 117.205,
    width: 37.6024,
    height: 37.6024,
    rx: 7.83133,
    fill: "url(#paint6_linear_77_341)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7932 141.976L77.2067 134.345C77.2443 133.725 77.451 133.217 77.8457 132.86C78.2404 132.503 78.7291 132.315 79.3305 132.315C79.9132 132.315 80.4018 132.465 80.7965 132.766C81.0033 132.935 81.1537 133.142 81.2476 133.424L83.9165 133.405C84.8563 133.405 85.3262 133.067 85.3074 132.371V132.353C85.2886 131.77 84.8563 131.469 83.9917 131.488L77.545 131.545L77.5638 127.071L83.1459 127.052H83.1835H83.2211C87.0365 127.034 89.1228 128.349 89.4799 130.981C89.9122 134.345 89.0664 136.375 86.9426 137.07L90.5325 141.976H85.3826L82.225 137.239L81.3792 137.221L81.492 141.976H76.7932Z",
    fill: "white"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_77_341)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 114.506,
    y: 112.506,
    width: 46.9879,
    height: 46.9879,
    rx: 12.5301,
    fill: "#474785"
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 119.205,
    y: 117.205,
    width: 37.6024,
    height: 37.6024,
    rx: 7.83133,
    fill: "url(#paint7_linear_77_341)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M141.329 131.545L137.683 131.526C136.311 131.507 135.615 131.845 135.597 132.503C135.578 132.898 135.785 133.086 136.217 133.105L138.679 133.123C139.187 133.142 139.562 133.274 139.863 133.518C140.126 133.762 140.277 134.119 140.277 134.571C140.277 135.022 140.164 135.36 139.938 135.585C139.713 135.83 139.299 135.961 138.679 135.98L135.897 136.055C135.503 136.074 135.352 136.262 135.409 136.657C135.446 136.901 135.54 137.127 135.709 137.333C135.954 137.615 137.157 137.766 139.318 137.785L142.269 137.803L142.288 142.277L137.608 142.314C133.04 142.314 130.747 140.623 130.747 137.221C130.747 136.901 130.766 136.544 130.823 136.187L131.217 132.841C131.687 128.97 133.886 127.034 137.814 127.052L141.329 127.071V131.545Z",
    fill: "white"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_77_341)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 167.759,
    y: 112.506,
    width: 46.9879,
    height: 46.9879,
    rx: 12.5301,
    fill: "#474785"
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 172.458,
    y: 117.205,
    width: 37.6024,
    height: 37.6024,
    rx: 7.83133,
    fill: "url(#paint8_linear_77_341)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M188.627 132.146L188.402 133.443C188.345 133.762 188.421 134.007 188.59 134.176C188.759 134.345 189.154 134.439 189.793 134.439C190.394 134.439 190.808 134.364 191.014 134.195C191.221 134.025 191.296 133.781 191.24 133.443L191.052 132.146C190.996 131.732 190.582 131.526 189.849 131.526C189.116 131.526 188.703 131.732 188.627 132.146ZM186.09 129.082C186.447 127.729 187.706 127.052 189.868 127.052C192.048 127.052 193.307 127.729 193.664 129.082L197.01 141.976H192.593L192.142 139.175C192.011 138.33 191.277 137.916 189.962 137.916C188.646 137.916 187.913 138.33 187.744 139.175L187.199 141.976H182.707L186.09 129.082Z",
    fill: "white"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d_77_341)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 221.012,
    y: 112.506,
    width: 46.9879,
    height: 46.9879,
    rx: 12.5301,
    fill: "#474785"
  }))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 225.711,
    y: 117.205,
    width: 37.6024,
    height: 37.6024,
    rx: 7.83133,
    fill: "url(#paint9_linear_77_341)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M238.641 131.338C238.077 131.338 237.626 131.131 237.288 130.736C236.968 130.323 236.799 129.815 236.799 129.233C236.799 128.631 236.931 128.143 237.213 127.767C237.476 127.372 237.946 127.184 238.641 127.165L250.332 126.902V131.451L245.971 131.413L246.178 141.976H241.629L241.723 131.375L238.641 131.338Z",
    fill: "white"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_d_77_341)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 165.759,
    width: 46.9879,
    height: 46.9879,
    rx: 12.5301,
    fill: "#666672"
  }))), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 12.6989,
    y: 170.458,
    width: 37.5904,
    height: 37.5904,
    rx: 7.83133,
    fill: "url(#paint10_linear_77_341)"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_d_77_341)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 167.759,
    y: 165.759,
    width: 46.9879,
    height: 46.9879,
    rx: 12.5301,
    fill: "#666672"
  }))), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 172.458,
    y: 170.458,
    width: 37.5904,
    height: 37.5904,
    rx: 7.83133,
    fill: "url(#paint11_linear_77_341)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_77_341",
    x: 53.2531,
    y: 0,
    width: 62.9879,
    height: 62.9879,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.322222 0 0 0 0 0.425333 0 0 0 0 0.483333 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_77_341"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_77_341",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_77_341",
    x: 159.759,
    y: 0,
    width: 62.9879,
    height: 62.9879,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.322222 0 0 0 0 0.425333 0 0 0 0 0.483333 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_77_341"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_77_341",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_77_341",
    x: 0,
    y: 53.2531,
    width: 62.9879,
    height: 62.9879,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.322222 0 0 0 0 0.425333 0 0 0 0 0.483333 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_77_341"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_77_341",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_77_341",
    x: 53.2531,
    y: 53.2531,
    width: 62.9879,
    height: 62.9879,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.322222 0 0 0 0 0.425333 0 0 0 0 0.483333 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_77_341"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_77_341",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_77_341",
    x: 159.759,
    y: 53.2531,
    width: 62.9879,
    height: 62.9879,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.322222 0 0 0 0 0.425333 0 0 0 0 0.483333 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_77_341"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_77_341",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_77_341",
    x: 0,
    y: 106.506,
    width: 62.9879,
    height: 62.9879,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.322222 0 0 0 0 0.425333 0 0 0 0 0.483333 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_77_341"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_77_341",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_77_341",
    x: 53.2531,
    y: 106.506,
    width: 62.9879,
    height: 62.9879,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.322222 0 0 0 0 0.425333 0 0 0 0 0.483333 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_77_341"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_77_341",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_77_341",
    x: 106.506,
    y: 106.506,
    width: 62.9879,
    height: 62.9879,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.322222 0 0 0 0 0.425333 0 0 0 0 0.483333 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_77_341"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_77_341",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_77_341",
    x: 159.759,
    y: 106.506,
    width: 62.9879,
    height: 62.9879,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.322222 0 0 0 0 0.425333 0 0 0 0 0.483333 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_77_341"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_77_341",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_77_341",
    x: 213.012,
    y: 106.506,
    width: 62.9879,
    height: 62.9879,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.322222 0 0 0 0 0.425333 0 0 0 0 0.483333 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_77_341"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_77_341",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_77_341",
    x: 0,
    y: 159.759,
    width: 62.9879,
    height: 62.9879,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.322222 0 0 0 0 0.425333 0 0 0 0 0.483333 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_77_341"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_77_341",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_77_341",
    x: 159.759,
    y: 159.759,
    width: 62.9879,
    height: 62.9879,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.322222 0 0 0 0 0.425333 0 0 0 0 0.483333 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_77_341"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_77_341",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_77_341",
    x1: 84.7531,
    y1: 10.6989,
    x2: 84.7531,
    y2: 48.3013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0C4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#474785"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_77_341",
    x1: 191.253,
    y1: 10.6989,
    x2: 191.253,
    y2: 48.2892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#576065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#787884"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_77_341",
    x1: 31.494,
    y1: 101.542,
    x2: 31.494,
    y2: 63.9519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F0C14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A43751"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_77_341",
    x1: 84.7531,
    y1: 63.9519,
    x2: 84.7531,
    y2: 101.554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0C4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#474785"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_77_341",
    x1: 191.253,
    y1: 63.9519,
    x2: 191.253,
    y2: 101.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#576065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#787884"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_77_341",
    x1: 31.5001,
    y1: 117.205,
    x2: 31.5001,
    y2: 154.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0C4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#474785"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_77_341",
    x1: 84.7531,
    y1: 117.205,
    x2: 84.7531,
    y2: 154.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0C4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#474785"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_77_341",
    x1: 138.006,
    y1: 117.205,
    x2: 138.006,
    y2: 154.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0C4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#474785"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_77_341",
    x1: 191.259,
    y1: 117.205,
    x2: 191.259,
    y2: 154.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0C4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#474785"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_77_341",
    x1: 244.512,
    y1: 117.205,
    x2: 244.512,
    y2: 154.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0C4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#474785"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_77_341",
    x1: 31.494,
    y1: 170.458,
    x2: 31.494,
    y2: 208.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#576065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#787884"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_77_341",
    x1: 191.253,
    y1: 170.458,
    x2: 191.253,
    y2: 208.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#576065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#787884"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGame1);
export default __webpack_public_path__ + "static/media/game1.934cc9b786b8af552381181cfe6a5dd3.svg";
export { ForwardRef as ReactComponent };